import { Component, ChangeDetectionStrategy } from "@angular/core";
import {
  PricingAndCostsData,
  UsageAndExtensionsData,
  TransportationData,
  LiabilityData,
  InspectionsData,
  DamageCoverage,
  RepairAndDamage,
  PreventativeMaintenanceData,
  CreditBillingPaymentsData,
} from "@rubbl-marketing";

@Component({
  selector: "app-rental-terms",
  templateUrl: "./rental-terms.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RentalTermsComponent {
  glossarySections = [
    PricingAndCostsData,
    UsageAndExtensionsData,
    TransportationData,
    LiabilityData,
    InspectionsData,
    DamageCoverage,
    RepairAndDamage,
    PreventativeMaintenanceData,
    CreditBillingPaymentsData,
  ];

  constructor() {}
}
